(ns rothko.component.spec
  (:require [clojure.spec.alpha :as s]))

(s/def ::id keyword?)

(s/def ::a-class
  (s/and
   (s/conformer keyword keyword)
   (s/or :string string? :keyword keyword?)))

(s/def ::class
  (s/coll-of ::a-class ;; :into #{}
             ))

(s/def ::appearance
  (s/coll-of keyword :kind set?))

(s/def ::theme
  keyword?)

(s/def ::props
  (s/or
   :map (s/keys :opt-un [::class ::appearance])
   :nil nil?))

(s/def ::href
  string?)

(s/def ::attrs
  (s/keys :opt-un [::href]))

;; This is an assumption on the structure of children which may not be true but
;; we can't use `any?` as then the `::defcomp-args` `s/alt` will 'choose' the
;; other option if say `attrs` are present but don't pass the spec due to how
;; `(s/* s/any?)` matches anything included invalid `attrs`.
(s/def ::children
  (s/* (s/or :vec vector? :str string? :nil nil?)))

(s/def ::props-and-children
  (s/cat
   :props ::props
   :children ::children))

(s/def ::props-attrs-and-children
  (s/cat
   :props ::props
   :attrs ::attrs
   :children ::children))

(s/def ::defcomp-args
  (s/alt
   :pac ::props-attrs-and-children
   :pc ::props-and-children))

(s/def ::hiccup
  (s/and
   (s/conformer vec vec)
   (s/cat
    :component (s/or :tag keyword?
                     :fn (s/and ifn? #(not (vector? %))))
    :props (s/? map?)
    :children (s/* (s/or
                    :string string?
                    :map map?
                    :number number?
                    :keyword keyword?
                    :element ::hiccup)))))
